import { Link } from 'react-router-dom';

const Footer = () => {

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <footer>
      
      <div className="content">

        <div className="pages">
          <h5 className="nav"><Link to="/" onClick={scrollToTop}>JLH</Link></h5>
          <h6 className="nav" id="footer-nav-games"><Link to="/games" onClick={scrollToTop}>Games</Link></h6>
          <h6 className="nav" id="footer-nav-modding"><Link to="/lucymod" onClick={scrollToTop}>Modding</Link></h6>
          <h6 className="nav" id="footer-nav-web-toys"><Link to="/toys" onClick={scrollToTop}>Web Toys</Link></h6>

          <div className="small-socials">

            <div className="ss-row" id="ss-row-1">
              <a href="mailto:minibonzogames@gmail.com">
                <img className="icon" src="/images/icons/email-icon.svg" alt="Email" />
              </a>
              <a href="https://bsky.app/profile/minibonzo.bsky.social" target="_blank">
                <img className="icon" src="/images/icons/bluesky-icon.svg" alt="Bluesky Logo" />
              </a>
            </div>

            <div className="ss-row" id="ss-row-2">
              <a href="https://twitter.com/minibonzo" target="_blank">
                <img className="icon" src="/images/icons/twitter-icon.svg" alt="Twitter Icon" />
              </a>
              <a href="https://apps.apple.com/gb/developer/jonah-heywood/id1602256326" target="_blank">
                <img className="icon" src="/images/icons/appstore-icon.svg" alt="App Store Icon" />
              </a>
            </div>
            
          </div>
        </div>

        <div className="socials">

          <a href="mailto:minibonzogames@gmail.com">
            <div className="icon-with-text">
              <img className="icon" src="/images/icons/email-icon.svg" alt="Email" />
              <h6 className="socials">minibonzogames@gmail.com</h6>
            </div>
          </a>

          <div className="space-4"></div>
          
          <a href="https://bsky.app/profile/minibonzo.bsky.social" target="_blank">
            <div className="icon-with-text">
              <img className="icon" src="/images/icons/bluesky-icon.svg" alt="Bluesky Logo" />
              <h6 className="socials">@minibonzo.bsky.social</h6>
            </div>
          </a>

          <div className="space-4"></div>

          <a href="https://twitter.com/minibonzo" target="_blank">
            <div className="icon-with-text">
              <img className="icon" src="/images/icons/twitter-icon.svg" alt="Twitter Icon" />
              <h6 className="socials">@minibonzo</h6>
            </div>
          </a>

          <div className="space-4"></div>

          <a href="https://apps.apple.com/gb/developer/jonah-heywood/id1602256326" target="_blank">
            <div className="icon-with-text">
              <img className="icon" src="/images/icons/appstore-icon.svg" alt="App Store Icon" />
              <h6 className="socials">Jonah Heywood</h6>
            </div>
          </a>

        </div>

        <div className="copyright">
          <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/"><img rel="license" alt="Creative Commons Licence" src="https://i.creativecommons.org/l/by-nc-nd/4.0/88x31.png" /></a>
          <p>
            This work is licensed under a <a href="https://creativecommons.org/licenses/by-nc-nd/4.0/">Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International License.</a>
          </p>
        </div>

      </div>

    </footer>
  );
}

export default Footer;